 <div tabindex="0">
 	<ul class="link-list">
 		<li *ngFor="let link of safeValue">
			<a 
				class="pointMe"
			    [href]="link.href" 
			    (click)="displayLinkMsg(link.originalHref, $event)"
			    target="_blank"> 
					<span [innerHTML]="link.name"></span>
			</a>
 		</li>
 	</ul>
 </div>
 